export default __webpack_public_path__ + "85e76ebb1692adb641978d570501e2eb.png";